import React from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Navbar } from "components"
import { useClickOutside } from "hooks"
import FailedPrinter from "./FailedPrinter"
import classes from "./FailedPrintersSidebar.module.scss"

const FailedPrintersSidebar = (props) => {
  const {
    openFailedPrintsSidebar,
    setOpenFailedPrintsSidebar,
    setSelectedFailedPrinter,
    selectedFailedPrinterIndex,
    setSelectedFailedPrinterIndex
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const failedPrints =
    useSelector(state => state.failedPrints)

  useClickOutside(() => {
    setOpenFailedPrintsSidebar(false)
  }, ["failed-prints-sidebar", "failed-prints-hamburger-button"])

  const getFailedPrinters = () => {
    const result = {}

    failedPrints.forEach(failedPrint => {
      const { printerIndex, printData } = failedPrint

      if (!!result[printerIndex]) {
        result[printerIndex].push(printData)
      } else {
        result[printerIndex] = [printData]
      }
    })

    return result
  }

  const failedPrinters = getFailedPrinters()

  const printerIndices = Object.keys(failedPrinters)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="failed-prints-sidebar"
      className={clsx(
        classes["sidebar"],
        isLtr && classes["sidebar-ltr"],
        openFailedPrintsSidebar && classes["show"],
        openFailedPrintsSidebar && isLtr && classes["show-ltr"]
      )}
    >
      <Navbar
        title={t("پرینت_های_انجام_نشده")}
        hideLeftIconInMobileView
        onLeftIconPress={() => history.push("/foods")}
        rightSideComponent={() =>
          <button
            className={classes["close"]}
            onClick={() => setOpenFailedPrintsSidebar(false)}
          >
            <MdClose
              color="white"
              size={25}
            />
          </button>
        }
      />

      {printerIndices.length > 0
        ?
        <div className={classes["sidebar-content"]}>
          {printerIndices.map(printerIndex =>
            <FailedPrinter
              key={printerIndex}
              printerIndex={Number(printerIndex)}
              selectedFailedPrinterIndex={selectedFailedPrinterIndex}
              setSelectedFailedPrinter={setSelectedFailedPrinter}
              setSelectedFailedPrinterIndex={setSelectedFailedPrinterIndex}
              totalFailedPrints={failedPrinters[printerIndex].length}
            />
          )}
        </div>
        :
        <div className={classes["no"]}>
          {t("هیچ_پرینت_انجام_نشده_ای_یافت_نشد")}
        </div>
      }
    </div>
  )
}


export default FailedPrintersSidebar